import Vue from 'vue';
import Router from 'vue-router';
import sensors from '../utils/sensors'
import api from './../api'
import routes from './routers';
import store from '../store/index';
import config from '../config/url';
import { Notify } from 'vant'

Vue.use(Router);
const router = new Router({
    mode: 'history',
    routes,
});

let params = {
    url: config.confUrl,
};
let frontendConfig = null

const SHOW_TABBARS = [ 'course', 'learning', 'saccount', 'goodsList','homepage']


router.beforeEach(async (to, from, next) => {
    const userInfo = localStorage.getItem('WDuserInfo') &&  JSON.parse(localStorage.getItem('WDuserInfo'));
    sessionStorage.setItem('realName',to.query.realName || from.query.realName || '');
    if(localStorage.getItem('token') && (to.query.phone == userInfo.phone)){
        if(to.query.realName==1){
            next('/idcard')
            return 
        }
        if(to.path=='/homepage' || to.path=='/goodsList' || to.path=="/learning"){
            console.log('-----------------------------------------------');
            checkJunmin(from,to,next)
            return 
        }
    }
    if(localStorage.getItem('token')){
        if(to.path=='/homepage' || to.path=='/goodsList' || to.path=="/learning"){
            checkJunmin(from,to,next)
            return 
        }
    }
    if (to.name === 'idcard' || to.name === 'cepverification' || to.name === 'goodsList' || to.name === 'goodsDetail') {
        store.state.idcardBefore = from.fullPath
    }
    if (to.query.distributionId) store.state.distributionId = to.query.distributionId
    !frontendConfig && await api.configuration.getConfigurationNew({ params }).then(res => {
        if (res.data) {
            frontendConfig = res.data.frontendConfig.filter(item => {
                if (item.key === 'homepage') {
                    return true;
                }
            })
            console.log("配置的首页是",frontendConfig)
            sessionStorage.setItem('theme',res.data.theme)
            sessionStorage.setItem('frontendConfig',JSON.stringify(res.data.frontendConfig))
            if (res.data.pageTitle) {
                document.title = res.data.pageTitle;
                localStorage.setItem('pageTitle', res.data.pageTitle)
            }
            if(res.data.solutionInfo){
                localStorage.setItem('solutionInfo',JSON.stringify(res.data.solutionInfo))
            }
        }
    })
    const token = localStorage.getItem('token')
    if(frontendConfig && token){
        if (localStorage.getItem('pageTitle')) {
            document.title = localStorage.getItem('pageTitle');
        }
    }
    if(to.meta && !to.meta.login){ //不需要登录
        next()
    }
    else if (to.path === '/goodsDetail' || to.path === '/goodsList') {
        next()
    } else {
        if (token) { //有权限
            if(!['setting','edit','myProfile','editProfile'].includes(to.name)){
                // 运动员登陆后需要判断是否完善资料
                if(sessionStorage.getItem('myProfile')=='myProfile'){
                    sessionStorage.removeItem('myProfile');
                    next();
                }else{
                    if(localStorage.getItem('token')){
                        checkJunmin(from,to,next)
                    }else{
                        next()
                    }
                }

            }else {
                next()
            }
        } else { // 无权限
            next('/login')
        }
    }

    if (SHOW_TABBARS.includes(to.name)) {
        store.commit('setTabbar', {
            show: true,
            active: to.name
        });
    } else {
        store.commit('setTabbar', { show: false });
    }
});

router.afterEach(() => {
    window.scrollTo(0, 0);
});
// 运动员否完善资料
async function checkJunmin(from,to,next){
    console.log('oooooooooooooooooooooooooooooo');
    const res2 = await api.usercenter.findUser()
    if(res2.code ==0 && res2.success){
        if(res2.data.areaCode && res2.data.userIdentity && res2.data.extra?.project  ){
            next()
        }else{
            if(from.path=='/login'){
                next('/myProfile')
            }else{
                Notify({
                    type: 'danger',
                    message: '请先完善个人资料',
                    duration: 2500,
                    onClose: () => {
                        next('/myProfile')
                    }
                })
            }
        }
    }   
}

export default router;
